$(document).ready( function() {

    if ( $('#ab-enabled').length ) {
        var viewCount = $('.lp-pageviews').data('pageviews');
        const paramsString = window.location.search;
        const newParams = new URLSearchParams(paramsString);

        if ( viewCount % 2 === 0 ) {
            // console.log('even');
            viewType = 'B';

            window.dataLayer.push({
                'event': 'kiwisaver_landingpage_b_view',
                'lp-ab-view': 'B_table_hidden'
            });

        } else {
            // console.log('odd');
            viewType = 'A';

            window.dataLayer.push({
                'event': 'kiwisaver_landingpage_a_view',
                'lp-ab-view': 'A_table_displayed'
            });
        }

        newParams.set('abview', viewType);
            
        var newUrl = window.location.origin 
            + window.location.pathname 
            + '?' + newParams.toString();

        window.history.pushState({path:newUrl},'',newUrl);

    }


    // OLD METHOD

    // if ( $('body.LandingPage').length ) {
    //     var abSet = $('div.abview').data('abview');

    //     // Update datalayer with each landing page view
    //     if ( abSet === 'A' ) {
    //         // table displayed
    //         window.dataLayer.push({
    //             'event': 'kiwisaver_landingpage_a_view',
    //             'lp-ab-view': 'A_table_displayed'
    //         });
    //     } else {
    //         // table hidden
    //         window.dataLayer.push({
    //             'event': 'kiwisaver_landingpage_b_view',
    //             'lp-ab-view': 'B_table_hidden'
    //         });
    //     }
    // }
});